














import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class InputText extends Vue {
    @Prop() id?: string;
    @Prop() name?: string;
    @Prop() placeholder?: string;
    @Prop() default?: string;
    @Prop() required?: boolean;
    @Prop() fieldClass?: string;
    @Prop() autocomplete?: string;
    @Prop() charpattern?: string;

    private value: string = this.default || '';
    private charPatternRegEx?: RegExp;

    @Watch('value')
    onPropertyChanged(value: string, oldValue: string) {
        this.$emit('update', value)
    }

    mounted() {
        this.init();
    }

    private init(): void {
        if (this.charpattern) {  
           this.charPatternRegEx = new RegExp(this.charpattern,'i'); 
        }
    }

    private checkCharPattern(event: KeyboardEvent) {
        if (this.charPatternRegEx!=undefined && !this.charPatternRegEx.test(event.key)) {
            event.preventDefault();
        }
    }
  }
